import SkeletonBox, { Props } from "./SkeletonBox";

const SkeletonTabs: React.FC<Props> = props => (
  <SkeletonBox {...props} h={50} maxWidth={400} borderRadius={40} />
);

export default SkeletonTabs;
